/// Minimal stand-in for Flame's Vector2. The game has no rotation or scaling,
/// so a plain mutable pair is all the engine ever needs.

export interface Vec2 {
  x: number;
  y: number;
}

export function vec2(x: number, y: number): Vec2 {
  return { x, y };
}

/// Fractional origin within a component's own box, matching Flame's Anchor.
export interface Anchor {
  x: number;
  y: number;
}

export const anchors = {
  topLeft: { x: 0, y: 0 } as Anchor,
  topCenter: { x: 0.5, y: 0 } as Anchor,
  bottomLeft: { x: 0, y: 1 } as Anchor,
  bottomCenter: { x: 0.5, y: 1 } as Anchor,
  center: { x: 0.5, y: 0.5 } as Anchor,
} as const;
